// extracted by mini-css-extract-plugin
export default {"row":"Contact_row__0CiYk","first-col":"Contact_first-col__VOvIf","arrow":"Contact_arrow__LI4Sm","employee-row":"Contact_employee-row__KAVGz"};